<ng-template #popContent><div [innerHTML]="text"></div></ng-template>
<button
  class="btn btn-light"
  [popoverTitle]="title"
  [ngbPopover]="popContent"
  [id]="id"
  [placement]="position ? position : 'right'"
  style="height: 100%; width: 48px"
>
  <fa-icon class="tooltipIcon" [icon]="iconQuestion"></fa-icon>
</button>
